import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
a:is(:hover,:focus,:active){
  color: #00aae4!important;
}
:root {
  --darkBlue: #030b53;
  --lightBlue: #00aae4;
  --welcome-h1-font-size:60px;
  --welcome-h3-font-size:38px;
  --welcome-p-font-size:26px;
  --font-percentage:1;
}
@media(max-width:1400px){
  :root{
    --font-percentage:0.91;
  }
}
@media(max-width:1200px){
  :root{
    --font-percentage:0.8;
  }
}
@media(max-width:991px){
  :root{
    --font-percentage:0.65;
  }
}
@media(max-width:767px){
  :root{
    --font-percentage:1;
    --welcome-h1-font-size:40px;
    --welcome-h3-font-size:25px;
    --welcome-p-font-size:20px;
  }
}
@media(max-width:350px){
  :root{
    --font-percentage:0.9;
  }

}
`;

export default GlobalStyles;
